<template>
    <div class="content">
      <admin-debtor-edit />
      <b-tabs content-class="mt-3">
        <b-tab active>
          <template slot="title">
            <font-awesome-icon icon="file-contract" /> {{ $t('debtors.debts') }}
          </template>
          <admin-debtor-debts/>
        </b-tab>
        <b-tab>
          <template slot="title">
            <font-awesome-icon icon="phone" rotation="90" /> {{ $t('phones.index') }}
          </template>
          <admin-debtor-phones/>
        </b-tab>
        <b-tab>
          <template slot="title">
            <font-awesome-icon icon="map-marked-alt" /> {{ $t('addresses.index') }}
          </template>
          <admin-debtor-addresses/>
        </b-tab>
        <b-tab>
          <template slot="title">
            <font-awesome-icon icon="building" /> {{ $t('workplaces.index') }}
          </template>
          <admin-debtor-workplaces/>
        </b-tab>
        <b-tab>
          <template slot="title">
            <font-awesome-icon icon="tenge" /> {{ $t('payments.index') }}
          </template>
          <admin-debtor-payments/>
        </b-tab>
      </b-tabs>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      errors: {},
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminDebtor',
    ]),
  },
  mounted() {
    this.GET_ADMIN_DEBTOR(this.$route.params.id);
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_DEBTOR',
    ]),
  },
  components: {
    AdminDebtorEdit: () => import('@/components/admin/debtors/edit.vue'),
    AdminDebtorDebts: () => import('@/components/admin/debtors/debts'),
    AdminDebtorPhones: () => import('@/components/admin/debtors/phones'),
    AdminDebtorAddresses: () => import('@/components/admin/debtors/addresses'),
    AdminDebtorWorkplaces: () => import('@/components/admin/debtors/workplaces'),
    AdminDebtorPayments: () => import('@/components/admin/debtors/payments'),
  },
};
</script>
